// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3keOS","colBig":"styles_colBig__1V15l","colSmall":"styles_colSmall__2LzDb"};